import { useNavigate, useParams } from "react-router-dom";
import { UrlPath } from "../../../config/routeConfig"
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../shared/topBar/TopBar"
import { sbaAxios } from "../../utils/sbaAxios";
import { InsertUpdateApprovalAPI, getApprovalListAPI, getApprovalStatusAPI, getDDQCategories, getDDQGetAllAnswers, getDDQInsertOrUpdateAnswer, getDDQQuestionsAndAnswer, getDDQsubCategories } from "../../../config/apiConfig";
import { useEffect, useState } from "react";
import { Accordion, Modal } from "react-bootstrap";
import { SBNotify } from "../../utils/sbNotify";
import { useDispatch, useSelector } from "react-redux";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { getAsset } from "../../actions/assetAction";
import { ToastContainer } from "react-toastify";
import info from '../../../Images/Info.svg';
import completedSVG from '../../../Images/green_completed.svg';
import recentTimer from '../../../Images/recentTimer.svg';
import moment from "moment";
import { Editor, EditorTools } from "@progress/kendo-react-all";

export const Duediligence = () => {
    const Gstate = useSelector((state) => state) || {};
    const params = useParams();
    const dispatch = useDispatch();
    const currentAsset = Gstate.asset.asset || {};
    const Level = [
    { BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` },
    {BreadCrumb: `${currentAsset.AssetName} >`,Routes: `${UrlPath.AssetDetails}${params.AssetId}`}, 
    { BreadCrumb: "Due Diligence", Routes: `${UrlPath.Duediligence}${params.AssetId}` }
    ]
    useEffect(() => {
        document.title = "Due Diligence";
        dispatch(getAssestListddlAction());
    }, []);

    useEffect(() => {
        dispatch(getAsset(params.AssetId));
    }, [params.AssetId]);
    return <>
        <TopBar label={"Due Diligence"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid">
                <div>
                    <CategoriesSection></CategoriesSection>
                </div>
            </div>
            <ToastContainer />
        </div>
    </>
}
const CategoriesSection = () => {
    const params = useParams();
    const history = useNavigate();
    const [categoryList, setCategoryList] = useState([]);
    const [expandAll, setExpandAll] = useState(false);
    const [expandedAcc, setexpandedAcc] = useState(0);


    const [selectedApproval, setSelectedApproval] = useState();
    const [approvalList, setApprovalList] = useState([]);
    const [addNewApproval, setAddNewApproval] = useState(false);
    const [confrimApproval, setConfrimApproval] = useState(false);
    const [publishMesage,setPublishMessage]=useState('Do you Want to Publish?');


    const Gstate = useSelector(state => state) || {};
    const currentAsset = Gstate.asset.asset || {};
    const AssetListDDL = Gstate.assetDDL.assetList || [];


    useEffect(() => {
        getApprovalList();
    }, [params?.AssetId]);

    const getApprovalList = async () => {
        try {
            const AL = await sbaAxios({ url: getApprovalListAPI + params.AssetId });
            setApprovalList(AL);
            if (AL.length > 0) {
                setSelectedApproval(AL[0]);
                getCategories(0, AL[0].ApprovalId, params.AssetId);
            }
            else {
                setSelectedApproval(null);
                getCategories(0, 0, params.AssetId);
            }
            return AL;
        } catch (error) {
            console.log(error, 'Error Fetching Approval List')
            return [];
        }
    };
    const AssetDDChanged = (e) => {
        if (e.value) {
            history(`${UrlPath.Duediligence}${e.value.AssetId}`);
        }
    };
    const updateAnswer = (answer, item, ans) => {
        setCategoryList(CatItem => (
            CatItem.map(Citem => {
                if (Citem.selected) {
                    Citem.subCategories = Citem.subCategories.map(itemm => {
                        if (itemm.SubCategoryId == item.SubCategoryId) {
                            itemm.question = itemm?.question?.map(ques => {
                                if (ques.QuestionId == item.QuestionId) {
                                    ques.Answer = answer;
                                    ques.Updated = true;
                                }
                                return ques
                            }) || [];
                        }
                        return itemm;
                    })
                }
                return Citem
            })
        ));
    };

    const saveAsAnswer = (selectedApproval) => {
        try {
            LanchSaveApprovalModal();
        } catch (error) {

        }

    };
  
    const saveAnswer = (selectedApproval, saveAs) => {
        try {
            const dataTobeSave=[];
            if (selectedApproval) {
                categoryList?.map(Citem => {
                    Citem?.subCategories?.map(sc => {
                        sc?.question.map(details => {
                            if (saveAs && details?.Answer) {
                                const preData = {
                                    "answerId": 0,
                                    "questionId": details.QuestionId,
                                    "assetId": params.AssetId,
                                    "approvalId": selectedApproval.ApprovalId,
                                    "answer": details.Answer
                                };
                               
                                dataTobeSave.push(preData);
                            }
                            else if (details.Updated) {
                                const preData = {
                                    "answerId": details.AnswerId,
                                    "questionId": details.QuestionId,
                                    "assetId": params.AssetId,
                                    "approvalId": selectedApproval.ApprovalId,
                                    "answer": details.Answer
                                };
                              
                                dataTobeSave.push(preData);
                            }
                        })
                    });
                })
                sbaAxios({ url: getDDQInsertOrUpdateAnswer, method: "post", data: dataTobeSave }).then(res => {
                }).catch(error => {
                });
                // ));
                if (saveAs)
                    SBNotify({ Msg: "Answers Saved Successfully" });
                else
                    SBNotify({ Msg: "Answers Updated Successfully" });

                FetchlatestAnswer(categoryList.findIndex(item => item.selected));
            }
            else {
                LanchSaveApprovalModal();
            }
        } catch (error) {

        }

    };
    const LanchSaveApprovalModal = () => {
        setAddNewApproval(true);
    };
    const saveNewApproval = (textValue) => {
        const preData = {
            "approvalId": 0,
            "assetId": params.AssetId,
            "approvalStatusId": 1,
            "approvalName": textValue,
            "lastApprovalId": 0
        }
        if(textValue=="" || !textValue)
        {
            SBNotify({Msg:"Please Enter an Approval Name" ,type:"error"})
            return;
        }
        if(approvalList.find(item=>item.ApprovalStatusId==1))
        {
            SBNotify({Msg:"An Approval draft is already present" ,type:"error"})
            return;
        }
        sbaAxios({ url: InsertUpdateApprovalAPI, method: "post", data: preData }).then(res => {
            if(res!=-1)
            {
                sbaAxios({ url: getApprovalListAPI + params.AssetId }).then(res1 => {
                    setApprovalList(res1);
                    setSelectedApproval(res1[0]);
                    setAddNewApproval(false);
                    saveAnswer(res1[0], true);
                    getCategories(0, res1[0].ApprovalId || 0, params.AssetId);
                });
            }
            else {
            SBNotify({Msg:"An Approval With Same Name Already Exist" ,type:"error"})
        }
           

        }).catch(error => {
        });

    };
    const FetchlatestAnswer = (id) => {
        if (selectedApproval?.ApprovalId) {
            getCategories(id, selectedApproval?.ApprovalId || 0, params.AssetId)
        }
    };

    const clearAnswer = (answer, item, ans) => {
        setCategoryList(CatItem => (
            CatItem.map(Citem => {
                if (Citem.selected) {
                    Citem.subCategories = Citem.subCategories.map(itemm => {
                        if (itemm.SubCategoryId == item.SubCategoryId) {
                            itemm.question = itemm?.question?.map(ques => {
                                if (ques.QuestionId == item.QuestionId) {
                                    ques.Answer = "";
                                    ques.Updated = true
                                }
                                return ques
                            }) || [];
                        }
                        return itemm;
                    })
                }
                return Citem
            })
        ));
    };
    const expandedAccordion = expandAll ? [...categoryList.find(cat => cat.selected).subCategories.map((item, index) => index)] : [expandedAcc];
    const getCategories = async (index, APID, AssetID) => {
        try {
            const categoryList = await sbaAxios({ url: getDDQCategories });
            const updatedSubCategories = await getSubCategories(APID, AssetID);
            const updatedCategoryList = categoryList.map((cat, inx) => ({ ...cat, text: cat.CategoryName, selected: index == inx, type: 'Category', subCategories: updatedSubCategories.filter(sub => sub.CategoryId == cat.CategoryId) }));
            setCategoryList(updatedCategoryList);
        } catch (error) {
            setCategoryList([]);
        }
    };
    const getSubCategories = async (id, AssetID) => {
        try {
            // const AL = await sbaAxios({ url: `${getDDQGetAllAnswers}/${id}/${AssetID}` });
            const QL = await sbaAxios({ url: getDDQQuestionsAndAnswer+id +'/'+AssetID });
            const resp = await sbaAxios({ url: getDDQsubCategories });
            const formattedQL=QL.map(item=>({AnswerTypeValues:item.AnswerTypeValues,...item.QuestionAndAnswer}))
            // const questionList = formattedQL.map(item => {
            //     let filAnswer = AL.find(ans => ans.QuestionId == item.QuestionId)
            //     if (filAnswer == undefined) {
            //         filAnswer = {
            //             "ParentQuestionId": 0,
            //             "QuestionId": item.QuestionId,
            //             "AssetId": params.AssetId,
            //             "SubCategoryId": item.SubCategoryId,
            //             "SubcategoryName": item.SubCategoryName,
            //             "CategoryId": item.CategoryId,
            //             "CategoryName": item.CategoryName,
            //             "QuestionTitle": item.QuestionTitle,
            //             "AnswerId": 0,
            //             "Answer": "",
            //             "ModifiedBy": 0,
            //             "ModifiedDate": "",
            //             "ModifiedByName": ""
            //         }
            //     }
            //     return { ...item }
            // });
            const subCategoryWithQuestion = resp?.map(sc => ({ ...sc, question: formattedQL.filter(item => item.SubCategoryId == sc.SubCategoryId) }));
            return subCategoryWithQuestion;

        } catch (error) {

        }
    };
    const totalAnswered = (input) => {
        let num = 0;
        input.map(Citem => {
            Citem?.subCategories?.map(item => {
                item?.question?.map(questions => {
                    if(questions?.Answer)
                    num ++;
                })
            })
        });
        return num;
    };
    const totalQuestions = (input) => {
        let num = 0;
        input.map(Citem => {
            Citem?.subCategories?.map(item => {
                num += item?.question?.length
            })
        })
        return num;
    };
    const totalCAnswered = (Citem) => {
        let num = 0;
        Citem?.subCategories?.map(item => {
            item?.question?.map(questions => {
                if(questions?.Answer)
                num ++;
            })
        })
        return num;
    };
    const totalCQuestions = (Citem) => {
        let num = 0;

        Citem?.subCategories?.map(item => {
            num += item?.question?.length
        });
        return num;
    };
    const showIscompleted = (item) => {
        if(totalCQuestions(item)==0)
        {
            return false;
        }
        return totalCAnswered(item) == totalCQuestions(item)
    }
    const isAnswer = (input) => {
    };
    const markSelected = (index) => {
        setCategoryList(val => {
            return val.map((item, sIndex) => ({ ...item, selected:false }))
        })
        setTimeout(() => {
            setCategoryList(val => {
                return val.map((item, sIndex) => ({ ...item, selected: index == sIndex }))
            });    
        }, 100);
        
    };
    const ApprovalChange = async (e) => {
        if (e.value) {
            const AS = await sbaAxios({ url: getApprovalStatusAPI + e.value.ApprovalId });
            setSelectedApproval(e.value);
            getCategories(0, e.value.ApprovalId, params.AssetId);
        }
    };
    const lanuchConfrimationModel=()=>{
            setConfrimApproval(true);
    };
    const UpdateApprovalStatus=(status)=>{
        const preData = {
            "approvalId": selectedApproval.ApprovalId,
            "assetId": params.AssetId,
            "approvalStatusId": status,
            "approvalName": selectedApproval.ApprovalName,
            "lastApprovalId": 0
        }
        if(status==1)
        {
            if(approvalList.find(item=>item.ApprovalStatusId==1))
            {
                SBNotify({Msg:"An Approval draft is already present",type:"error"})
                return;
            }
        }
        if(status==3)
        {
            let AnsweredQuestion = 0;
            categoryList.map(Citem => {
                Citem?.subCategories?.map(item => {
                    item?.question?.map(questions => {
                        if(questions?.Answer)
                        AnsweredQuestion ++;
                    })
                })
            });
            let TotalQuestion = 0;
            categoryList.map(Citem => {
                Citem?.subCategories?.map(item => {
                    TotalQuestion += item?.question?.length
                })
            })
            if(AnsweredQuestion==0)
            {
                setPublishMessage(val=>'No Question Have Been Answered! Do you want to publish?');
            }
            else 
            {
                setPublishMessage(val=>'Do you Want to Publish?');

            }
            setTimeout(() => {
                lanuchConfrimationModel();                
            }, 100);
            return;
        }
        sbaAxios({ url: InsertUpdateApprovalAPI, method: "post", data: preData }).then(res => {
            sbaAxios({ url: getApprovalListAPI + params.AssetId }).then(res1 => {
                const filterApproval=res1.find(item=>item.ApprovalId==preData.approvalId)
                setApprovalList(res1);
                setSelectedApproval(filterApproval);
                //setAddNewApproval(false);
                //saveAnswer(res1[0], true);
                getCategories(0, filterApproval.ApprovalId || 0, params.AssetId);
                SBNotify({Msg:"Approval Status Updated Sucessfully"})

            });

        }).catch(error => {
        })
    };
   
    const saveConfrimedApproval=()=>{
        const preData = {
            "approvalId": selectedApproval.ApprovalId,
            "assetId": params.AssetId,
            "approvalStatusId": 3,
            "approvalName": selectedApproval.ApprovalName,
            "lastApprovalId": 0
        };
        sbaAxios({ url: InsertUpdateApprovalAPI, method: "post", data: preData }).then(res => {
            sbaAxios({ url: getApprovalListAPI + params.AssetId }).then(res1 => {
                const filterApproval=res1.find(item=>item.ApprovalId==preData.approvalId)
                setApprovalList(res1);
                setSelectedApproval(filterApproval);
                //setAddNewApproval(false);
                //saveAnswer(res1[0], true);
                getCategories(0, filterApproval.ApprovalId || 0, params.AssetId);
                SBNotify({Msg:"Approval Status Updated Sucessfully"})

            });

        }).catch(error => {
        });
        setConfrimApproval(false);

    };
    return <>
        <div className="container-fluid mb-0" >
            {true && <>
                <div className="my-2 detail p-3 mb-0">
                    <div className="d-flex  gap-4" style={{minHeight:"100px"}}>

                        <div className="w-25">
                            <label htmlFor="select fund" className="mb-1">
                                Asset
                            </label>
                            <SBAComboBox
                                value={currentAsset}
                                onChange={AssetDDChanged}
                                data={AssetListDDL}
                                textField="AssetName"
                                valueField="AssetId"
                            />
                        </div>
                        <div className="w-50 d-flex gap-4">
                            <div>
                                <label htmlFor="select fund" className="mb-1 d-block">
                                    Name
                                </label>
                                <SBAComboBox
                                    value={selectedApproval}
                                    onChange={(e) => { ApprovalChange(e) }}
                                    data={approvalList}
                                    textField="ApprovalName"
                                    valueField="ApprovalId"
                                    className=""
                                />
                            </div>
                            <div>
                                <label htmlFor="select fund" className="mb-1 d-block">
                                    Status
                                </label>
                                {selectedApproval?.ApprovalStatusId==1 &&<>
                                    <span>
                                    <span className="w-25">
                                        <CircularProgress strokeWidth={20} value={totalAnswered(categoryList) / totalQuestions(categoryList) * 100} />
                                    </span>
                                    
                                    <span className="mx-2" style={{whiteSpace:"nowrap"}}>In-Progress</span>
                                    <div>
                                        {"Answered " + totalAnswered(categoryList) + " out of " + totalQuestions(categoryList)}
                                    </div>
                                </span>
                                    </>}
                                {selectedApproval?.ApprovalStatusId==3 && <>
                                    <span>
                                    <span className="w-25">
                                    <img src={completedSVG} />   
                                    </span>
                                    <span className="mx-2" style={{whiteSpace:"nowrap"}}>Published</span>
                                </span>
                                    </>}
                                
                            </div>

                        </div>
                        <div className="w-25">

                        </div>
                        <div className="ms-auto d-flex">
                            {selectedApproval?.ApprovalStatusId==3 && <>
                                <button className="s-sm-btn mx-1 ms-auto row-items mt-auto" onClick={() => { UpdateApprovalStatus(1) }}> {"Revert to Draft"} </button>
                            </>}
                            {selectedApproval?.ApprovalStatusId==1 && <>
                                <button className="s-sm-btn mx-1 row-items mt-auto" onClick={() => { UpdateApprovalStatus(3) }}> {"Publish"} </button>                            
                            </>}
                            <button className="s-sm-btn mx-1 row-items mt-auto" onClick={() => { setExpandAll(val => !val); setexpandedAcc(-1) }}> {expandAll ? "Collapse All" : "Expand All"} </button>
                            {/* <button className="s-sm-btn mx-2 row-items mt-auto" onClick={() => { FetchlatestAnswer(categoryList.findIndex(item => item.selected)); }}>Reset</button> */}
                            {approvalList.length>0 && approvalList.filter(item=>item.ApprovalStatusId==1).length==0 &&<>
                                <button className={"p-sm-btn mx-1 row-items mt-auto"} onClick={() => { saveAsAnswer(selectedApproval) }}>Save As</button>
                            </>}
                            {selectedApproval?.ApprovalStatusId!=3 && <>
                                <button className="p-sm-btn mx-1 row-items mt-auto"  onClick={() => { saveAnswer(selectedApproval) }}>Save</button>
                            </>}
                        </div>
                    </div>
                </div>
                {selectedApproval?.ApprovalId && <div className="p-2 mb-2 detail" style={{ backgroundColor: "#e4ebf0" }}>
                   {selectedApproval?.ApprovalStatusId==3 ? "Published by": "Last Modified by" }  {selectedApproval?.DisplayName} on {moment(selectedApproval?.ModifiedDate).format("MM/DD/YYYY, h:mma")}
                </div>}


            </>}

            {categoryList.map((item, index) => (<><button className={item.selected ? "p-sm-btn m-1" : "s-sm-btn m-1"} onClick={() => { markSelected(index) }}>{item.text}  {showIscompleted(item) && <img src={completedSVG} />}  </button></>))}
            <div className="row h-100 w-100" >

                <div  className="col-12 mt-2">
                    <>
                        <h3 className="my-4">{categoryList.find(item => item.selected)?.CategoryName}</h3>
                        <Accordion activeKey={expandedAccordion} onSelect={(e) => { setexpandedAcc(val => { if (val == e) return -1; else return e }); setExpandAll(false); }}>
                            {categoryList.find(item => item.selected)?.subCategories?.map((item, index) => <>
                                <Accordion.Item eventKey={index}>
                                    <Accordion.Header>{item?.SubCategoryName}   </Accordion.Header>
                                    <Accordion.Body >
                                        {item?.question?.map(qu => <div className={`mb-4`} style={{ marginLeft: qu?.IndentLevel * 24 + "px" }} >
                                            <h6 className="my-3">{qu?.QuestionTitle}</h6>

                                            <div>
                                            <>
                                                       
                                                        {qu.AnswerTypeName == "HtmlText" && <>
                                                        <div className="d-flex">
                                                            <p className={`m-0 col-8 my-1`}>{qu.Question} <span className="opacity-50 SBA_hand" ><img src={info} alt="Info" title="Need to implement" /></span></p>
                                                            <div className="ms-auto d-flex">
                                                                <img src={recentTimer} className="mx-1" alt="timer" height={'20px'} width={'20px'} />  <div style={{ whiteSpace: 'nowrap' }}>
                                                                    Last Modified: {qu?.AnswerId  ? qu?.ModifiedByName + " ," + moment(qu?.ModifiedDate).format("MM/DD/YYYY, h:mma") : "N/A"}
                                                                </div>

                                                                {/* {/ <i class="fa-solid fa-floppy-disk text-primary SBA_hand mx-2" onClick={()=>{saveAnswer(qu)}}></i> /} */}
                                                                {/* {qu?.answer?.filter(item => item.DDQNoteId != 0).length > 0 && qu?.answer?.filter(item => item.DDQNoteId == 0).length == 1 && <><i class="fa-solid fa-close text-danger SBA_hand mx-2" onClick={() => { removeAnswer(qu) }}></i></>} */}
                                                                {/* {qu?.answer?.filter(item => item?.AnswerId != 0).length == 0 && qu?.answer?.filter(item => item.Updated).length > 0 && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>} */}

                                                                {qu.AnswerTypeName != "HtmlText" && qu.Updated && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>}
                                                            </div>
                                                        </div>
                                                        <>
                                                        <HTMLEditor question={qu} updateAnswer={(e,e1,e2)=>{updateAnswer(e,e1,e2)}}/>
                                                        </>
                                                            
                                                        </>
                                                        }
                                                        {qu.AnswerTypeName == "Boolean" &&
                                                            <>
                                                             <div className="d-flex">
                                                            <p className={`m-0 col-8`}>{qu.Question} <span className="opacity-50 SBA_hand" ><img src={info} alt="Info" title="Need to implement" /></span></p>
                                                            <div className="ms-auto d-flex">
                                                                <img src={recentTimer} className="mx-1" alt="timer" height={'20px'} width={'20px'} />  <div style={{ whiteSpace: 'nowrap' }}>
                                                                    Last Modified: {qu?.AnswerId  ? qu?.ModifiedByName + " ," + moment(qu?.ModifiedDate).format("MM/DD/YYYY, h:mma") : "N/A"}
                                                                </div>

                                                                {/* {/ <i class="fa-solid fa-floppy-disk text-primary SBA_hand mx-2" onClick={()=>{saveAnswer(qu)}}></i> /} */}
                                                                {/* {qu?.answer?.filter(item => item.DDQNoteId != 0).length > 0 && qu?.answer?.filter(item => item.DDQNoteId == 0).length == 1 && <><i class="fa-solid fa-close text-danger SBA_hand mx-2" onClick={() => { removeAnswer(qu) }}></i></>} */}
                                                                {/* {qu?.answer?.filter(item => item?.AnswerId != 0).length == 0 && qu?.answer?.filter(item => item.Updated).length > 0 && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>} */}

                                                                {qu.AnswerTypeName != "HtmlText" && qu.Updated && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>}
                                                            </div>
                                                        </div>
                                                                <div className="">
                                                                    <button  className={qu?.Answer == 'Yes' ? "p-sm-btn mx-1" : "s-sm-btn mx-1"} onClick={() => { updateAnswer('Yes', qu, index) }}> Yes</button>
                                                                    <button className={qu?.Answer == 'No' ? "p-sm-btn mx-1" : "s-sm-btn mx-1"} onClick={() => { updateAnswer('No', qu, index) }}>No</button>
                                                                </div>
                                                            </>
                                                        }
                                                        {qu.AnswerTypeName == "Text" && <>
                                                        <div className="d-flex">
                                                            <p className={`m-0 col-8`}>{qu.Question} <span className="opacity-50 SBA_hand" ><img src={info} alt="Info" title="Need to implement" /></span></p>
                                                            <div className="ms-auto d-flex">
                                                                <img src={recentTimer} className="mx-1" alt="timer" height={'20px'} width={'20px'} />  <div style={{ whiteSpace: 'nowrap' }}>
                                                                    Last Modified: {qu?.AnswerId  ? qu?.ModifiedByName + " ," + moment(qu?.ModifiedDate).format("MM/DD/YYYY, h:mma") : "N/A"}
                                                                </div>

                                                                {/* {/ <i class="fa-solid fa-floppy-disk text-primary SBA_hand mx-2" onClick={()=>{saveAnswer(qu)}}></i> /} */}
                                                                {/* {qu?.answer?.filter(item => item.DDQNoteId != 0).length > 0 && qu?.answer?.filter(item => item.DDQNoteId == 0).length == 1 && <><i class="fa-solid fa-close text-danger SBA_hand mx-2" onClick={() => { removeAnswer(qu) }}></i></>} */}
                                                                {/* {qu?.answer?.filter(item => item?.AnswerId != 0).length == 0 && qu?.answer?.filter(item => item.Updated).length > 0 && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>} */}

                                                                {qu.AnswerTypeName != "HtmlText" && qu.Updated && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>}
                                                            </div>
                                                        </div>
                                                        <TextEditor  question={qu} updateAnswer={(e1,e2,e3)=>{updateAnswer(e1,e2,e3)}} ></TextEditor>
                                                        
                                                        </>
                                                        }
                                                        {qu?.AnswerTypeName?.includes("List") &&
                                                        <>
                                                        {qu?.AnswerTypeValues.length>5 && <>
                                                            <div className="d-flex">
                                                            <p className={`m-0 col-8`}>{qu.Question} <span className="opacity-50 SBA_hand" ><img src={info} alt="Info" title="Need to implement" /></span></p>
                                                            <div className="ms-auto d-flex">
                                                                <img src={recentTimer} className="mx-1" alt="timer" height={'20px'} width={'20px'} />  <div style={{ whiteSpace: 'nowrap' }}>
                                                                    Last Modified: {qu?.AnswerId  ? qu?.ModifiedByName + " ," + moment(qu?.ModifiedDate).format("MM/DD/YYYY, h:mma") : "N/A"}
                                                                </div>

                                                                {/* {/ <i class="fa-solid fa-floppy-disk text-primary SBA_hand mx-2" onClick={()=>{saveAnswer(qu)}}></i> /} */}
                                                                {/* {qu?.answer?.filter(item => item.DDQNoteId != 0).length > 0 && qu?.answer?.filter(item => item.DDQNoteId == 0).length == 1 && <><i class="fa-solid fa-close text-danger SBA_hand mx-2" onClick={() => { removeAnswer(qu) }}></i></>} */}
                                                                {/* {qu?.answer?.filter(item => item?.AnswerId != 0).length == 0 && qu?.answer?.filter(item => item.Updated).length > 0 && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>} */}

                                                                {/* {qu.Updated && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>} */}
                                                            </div>
                                                        </div>
                                                        <DropDownEditor question={qu} updateAnswer={(e1,e2,e3)=>{updateAnswer(e1,e2,e3)}}></DropDownEditor>

                                                        </>}
                                                        {qu?.AnswerTypeValues.length<6 &&  
                                                        <>
                                                        <div className="d-flex">
                                                            <p className={`m-0 col-8`}>{qu.Question} <span className="opacity-50 SBA_hand" ><img src={info} alt="Info" title="Need to implement" /></span></p>
                                                            <div className="ms-auto d-flex">
                                                                <img src={recentTimer} className="mx-1" alt="timer" height={'20px'} width={'20px'} />  <div style={{ whiteSpace: 'nowrap' }}>
                                                                    Last Modified: {qu?.AnswerId  ? qu?.ModifiedByName + " ," + moment(qu?.ModifiedDate).format("MM/DD/YYYY, h:mma") : "N/A"}
                                                                </div>

                                                                {/* {/ <i class="fa-solid fa-floppy-disk text-primary SBA_hand mx-2" onClick={()=>{saveAnswer(qu)}}></i> /} */}
                                                                {/* {qu?.answer?.filter(item => item.DDQNoteId != 0).length > 0 && qu?.answer?.filter(item => item.DDQNoteId == 0).length == 1 && <><i class="fa-solid fa-close text-danger SBA_hand mx-2" onClick={() => { removeAnswer(qu) }}></i></>} */}
                                                                {/* {qu?.answer?.filter(item => item?.AnswerId != 0).length == 0 && qu?.answer?.filter(item => item.Updated).length > 0 && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>} */}

                                                                {qu.AnswerTypeName != "HtmlText" && qu.Updated && <><i class="fa-solid fa-trash text-danger SBA_hand mx-2" onClick={() => { clearAnswer("", qu, index) }}></i></>}
                                                            </div>
                                                        </div>
                                                        <span className="d-flex w-50">
                                                                {qu?.AnswerTypeValues?.map(values=>(<>
                                                                    <button className={qu?.Answer == values.AnswerTypeValueName ? "p-sm-btn mx-1" : "s-sm-btn mx-1"} onClick={() => { updateAnswer(values?.AnswerTypeValueName || "", qu, index) }}> {values.AnswerTypeValueName}</button>    
                                                                </>))}
                                                            </span> 
                                                        </>
                                                        }
                                                        </>     
                                                        }
                                                    </>
                                            </div>
                                        </div>)}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </>)}
                        </Accordion >
                    </>
                </div>
            </div>
        </div>
        {addNewApproval && <>
            <InsertUpdateApproval showModel={addNewApproval} setShowModel={setAddNewApproval} fun={saveNewApproval} />
        </>}
        {confrimApproval && <>
            <ApprovalConfrimationModal text={publishMesage} showModel={confrimApproval} setShowModel={setConfrimApproval} fun={saveConfrimedApproval} />
        </>}
    </>
};
const CircularProgress = ({ value, size = 100, strokeWidth = 10 }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (value / 100) * circumference;

    return (
        <svg
            width={30}
            height={30}
            viewBox={`0 0 ${size} ${size}`}
            xmlns="http://www.w3.org/2000/svg"
        >

            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke="#d3d3d3"
                strokeWidth={strokeWidth}
                fill="none"
            />

            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke="#4caf50"
                strokeWidth={strokeWidth}
                fill="none"
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                strokeLinecap="round"
                style={{
                    transition: "stroke-dashoffset 0.35s",
                    transform: "rotate(-90deg)",
                    transformOrigin: "center",
                }}
            />
        </svg>
    );
};
const InsertUpdateApproval = ({ showModel, setShowModel, fun }) => {
    const [textValue, setTextValue] = useState("");
    // const [includeLastAnswer,setIncludeLastAnswer]=useState(false);
    const handleSaveClick = () => {
        fun(textValue,);
    }
    return <>
        <Modal show={showModel} onHide={() => setShowModel(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Add New DDQ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div >
                    <span>Approval Name</span>
                    <input type="text" className="form-control my-2" value={textValue} onChange={(e) => { setTextValue(e.target.value) }} />
                    {/* <span className="m-2">included Last Answer</span> */}
                    {/* <input type="checkbox" checked={includeLastAnswer}   onChange={(e)=>{setIncludeLastAnswer(e.target.checked)}} /> */}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={() => setShowModel(false)}>
                    Cancel
                </button>
                <button
                    className="p-sm-btn mx-1"
                    onClick={() => { handleSaveClick() }}
                >
                    Save
                </button>
            </Modal.Footer>
        </Modal>
    </>
};
const ApprovalConfrimationModal = ({ showModel, setShowModel, fun , text }) => {
    return <>
        <Modal show={showModel} onHide={() => setShowModel(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Publish DDQ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div >
                    <h4>{text}</h4>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={() => setShowModel(false)}>
                    Cancel
                </button>
                <button
                    className="p-sm-btn mx-1"
                    onClick={() => { fun() }}
                >
                    Publish
                </button>
            </Modal.Footer>
        </Modal>
    </>
};
const HTMLEditor = ({updateAnswer, question}) => {
    const [selectedQuestion,setSelectedQuestion]=useState(question);
   

    useEffect(()=>{
        setSelectedQuestion(question)
    },[question]);
    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,
        FontName,
        FormatBlock,
        Link,
        Unlink,
        InsertImage,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;
    return <>
        <Editor tools={[[Bold,
            Italic,
            Underline,
            Strikethrough,
            Subscript,
            Superscript,
            AlignLeft,
            AlignCenter,
            AlignRight,
            AlignJustify,
            OrderedList,
            UnorderedList,
            FontSize,
            FontName,
            FormatBlock,
            Link,
            InsertImage,
            ViewHtml,
        ]]} contentStyle={{
            height: 400
        }}
            onChange={(e) => {
                if (e.html != '<p></p>')
                    updateAnswer(e.html, selectedQuestion, 0)
                else
                    updateAnswer("", selectedQuestion, 0)

            }}
            value={selectedQuestion?.Answer || ""}
        />
    </>
};
const DropDownEditor = ({ updateAnswer, question }) => {
    const [selectedQuestion,setSelectedQuestion]=useState(question);
    useEffect(()=>{
        setSelectedQuestion(question)
    },[question]);
    return <>
        <SBAComboBox className="w-25" data={selectedQuestion?.AnswerTypeValues || []} value={selectedQuestion?.AnswerTypeValues.find(item => item.AnswerTypeValueId == selectedQuestion?.Answer) || null} textField={"AnswerTypeValueName"} valueField={"AnswerTypeValueId"} onChange={(e) => { updateAnswer(e?.value?.AnswerTypeValueId || "", selectedQuestion, 0) }} ></SBAComboBox >
    </>
};
const TextEditor = ({ updateAnswer, question }) => {
    const [selectedQuestion, setSelectedQuestion] = useState(question);
    useEffect(() => {
        setSelectedQuestion(question)
    }, [question]);
    return <>
        <textarea  className="form-control my-2" value={selectedQuestion?.Answer || ""} onChange={(e) => { updateAnswer(e.target.value, selectedQuestion, 0) }}></textarea>
    </>
};